import { StoreState } from '../types';
import {
  SetEmailVerificationData,
  SET_EMAIL_VERIFICATION_DATA
} from '../actions';

export default {
  emailVerificationData
};

export function emailVerificationData(
  state: StoreState['emailVerificationData'],
  action: SetEmailVerificationData
) {
  switch (action.type) {
    case SET_EMAIL_VERIFICATION_DATA:
      return action.emailVerificationData || null;
    default:
      return state || null;
  }
}

export function getEmailVerificationData(state: StoreState) {
  return state.emailVerificationData;
}



// WEBPACK FOOTER //
// ./src/reducers/emailVerification.ts